import React from 'react';

import { Container, Typography } from '@material-ui/core';

import useStyles from './styles';

const Dashboard: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <main className={classes.content}>
        <Container maxWidth="lg" className={classes.container}>
          <Typography>Dashboard content</Typography>
        </Container>
      </main>
    </div>
  );
};

export default Dashboard;
